function hitBottom() {

	const d = document.documentElement;
	const f = document.querySelector('.body-wrapper .footer .bar-bottom');

	const offset = d.scrollTop + window.innerHeight;
	const height = d.offsetHeight - f.offsetHeight;

	return (offset >= height);
}

module.exports = function () {
	window.onscroll = function(e) {
		const ele = document.querySelector('body .morningcatch .mt-trigger');
		const margin = document.querySelector('.body-wrapper .footer .bar-bottom').offsetHeight;

		if (ele) {
			if (hitBottom()) ele.style.marginBottom = `${margin}px`;
			else ele.style.marginBottom = 0;

			//if (hitBottom()) ele.classList.add('hit-bottom');
			//else ele.classList.remove('hit-bottom');
		}
	}
}
